/* tslint:disable */
/* eslint-disable */
/**
 * Referentials API
 * API for managing referentials, including countries, civility titles, and nationalities.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Referential key options for various data categorization
 * @export
 */
export const ReferentialKey = {
    /**
    * Civility referential (Mr., Mrs., etc.)
    */
    Civility: 0,
    /**
    * Legal form referential (SARL, SAS, etc.)
    */
    LegalForm: 1,
    /**
    * Nationality referential
    */
    Nationality: 2,
    /**
    * Country referential
    */
    Country: 3,
    /**
    * Company role referential (CEO, Manager, etc.)
    */
    CompanyRole: 4,
    /**
    * Mandate frequency referential (Monthly, Quarterly, etc.)
    */
    MandateFrequency: 5,
    /**
    * Questions contexts referential
    */
    QuestionsContexts: 6,
    /**
    * Project type referential
    */
    ProjectType: 7,
    /**
    * Insurance project referential
    */
    InsuranceProject: 8,
    /**
    * Loan type referential
    */
    LoanType: 9,
    /**
    * Deferment type referential
    */
    DefermentType: 10,
    /**
    * Interest rate type referential
    */
    InterestRateType: 11,
    /**
    * Prospect type referential
    */
    ProspectType: 12,
    /**
    * Employment status referential
    */
    EmploymentStatus: 13,
    /**
    * Income type referential
    */
    IncomeType: 14,
    /**
    * Plateforme referential
    */
    Plateforme: 15,
    /**
    * Role referential
    */
    Role: 16,
    /**
    * Intermediate category referential
    */
    IntermediateCategory: 17,
    /**
    * Branch referential
    */
    Branch: 18,
    /**
    * Note priority referential
    */
    NotePriority: 19,
    /**
    * Note status referential
    */
    NoteStatus: 20,
    /**
    * Note tag referential
    */
    NoteTag: 21,
    /**
    * Contract periodicity referential (Monthly, Quarterly, Annual, etc.)
    */
    ContractPeriodicity: 22,
    /**
    * Notice unit referential (Days, Weeks, Months, Years)
    */
    NoticeUnit: 23
} as const;
export type ReferentialKey = typeof ReferentialKey[keyof typeof ReferentialKey];


export function instanceOfReferentialKey(value: any): boolean {
    for (const key in ReferentialKey) {
        if (Object.prototype.hasOwnProperty.call(ReferentialKey, key)) {
            if (ReferentialKey[key as keyof typeof ReferentialKey] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReferentialKeyFromJSON(json: any): ReferentialKey {
    return ReferentialKeyFromJSONTyped(json, false);
}

export function ReferentialKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferentialKey {
    return json as ReferentialKey;
}

export function ReferentialKeyToJSON(value?: ReferentialKey | null): any {
    return value as any;
}

export function ReferentialKeyToJSONTyped(value: any, ignoreDiscriminator: boolean): ReferentialKey {
    return value as ReferentialKey;
}

